import { EntityAdapter, createEntityAdapter } from "@ngrx/entity";
import { PageContent } from "../../models/page-content.model";

export const pagesAdapter: EntityAdapter<PageContent> = createEntityAdapter<PageContent>({
    selectId: state => state.pageID
});